/** Alert policy classifies canonical changes; it never calculates intelligence. */
export const scoreAlertThresholds=Object.freeze([40,60,75,90] as const);
export const defaultAlertThresholds={transferAttentionDays:3,eventInventoryRiskDays:7,watchlistEventDays:7,staleListingDays:14};
